import { Button } from "@progress/kendo-react-buttons";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";

export default function Notifications({ notifications, onClose }) {
  return (
    <NotificationGroup className="notifications">
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          type={{ style: notification.type, icon: true }}
          closable
          onClose={() => onClose(notification.id)}
        >
          <div className="notification-content">
            <span className="notification-text">{notification.message}</span>
            {notification.actionLabel && (
              <Button
                fillMode="flat"
                onClick={() => {
                  notification.onAction?.();
                  onClose(notification.id);
                }}
              >
                {notification.actionLabel}
              </Button>
            )}
          </div>
        </Notification>
      ))}
    </NotificationGroup>
  );
}
